export const difficulties = [
  {
    id: '0',
    name: 'Qualquer dificuldade',
  },
  {
    id: 'easy',
    name: 'Fácil',
  },
  {
    id: 'medium',
    name: 'Normal',
  },
  {
    id: 'hard',
    name: 'Difícil',
  },
];

export const types = [
  {
    id: '0',
    name: 'Qualquer tipo',
  },
  {
    id: 'multiple',
    name: 'Múltipla escolha',
  },
  {
    id: 'boolean',
    name: 'Verdadeiro ou falso',
  },
];
